"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.azureRoleEnvironmentTelemetryProcessor = void 0;
/**
 *  @deprecated The method should not be called, Azure Properties will be added always when available
 *  A telemetry processor that handles Azure specific variables.
 */
function azureRoleEnvironmentTelemetryProcessor(envelope, context) {
    // NO-OP
}
exports.azureRoleEnvironmentTelemetryProcessor = azureRoleEnvironmentTelemetryProcessor;
//# sourceMappingURL=AzureRoleEnvironmentTelemetryInitializer.js.map